import React from 'react'


import {WeatherDetails,LocationDetails} from './container'

import './App.scss'
import WeatherForecast from './container/WeatherForecast/WeatherForecast'
const App = () => {

  
  return (
    <div className='app__flex'>
      <LocationDetails/>
      <WeatherDetails/>
      <WeatherForecast/>

    </div>
  )
}

export default App